import { authApiService } from '@/api/authApiService';
import { ApiResponseType, AuthResponseType } from '@/types/sharedTypes';

export const sendTwoFAApi = async (data): Promise<ApiResponseType<AuthResponseType>> => {
  const uri = `/users/auth/2fa/`;

  return authApiService.POST(uri, data);
};
